module.exports = __webpack_public_path__ + "img/filter.836b7395.svg";